import { Immutable } from '@zervant/reactcomponents'
import { AccountInterface } from 'client/Interfaces/AccountsInterface'

import { ReducerBuilder } from './ReducerBuilder'

const INITIAL_STATE = null

type StateType = AccountInterface[] | null
type PayloadType = AccountInterface[]

// eslint-disable-next-line no-underscore-dangle
function _getAccounts(state: StateType, payload: PayloadType): StateType {
  return Immutable.copy(payload)
}

const reducer = ReducerBuilder.create<StateType, PayloadType>(INITIAL_STATE)
  .mapAction('GET_ACCOUNTS', _getAccounts)
  .build()

export default reducer
